module.exports = __webpack_public_path__ + "img/bg.dec042e5.png";